
import React from 'react';
import { Header } from '../../components/feature/Header';
import { BottomNav } from '../../components/feature/BottomNav';
import { HeroSection } from './components/HeroSection';
import { CategoryGrid } from './components/CategoryGrid';
import { FeaturedProducts } from './components/FeaturedProducts';
import { DealsSection } from './components/DealsSection';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Main Content */}
      <main className="pt-20 pb-20">
        <HeroSection />
        <CategoryGrid />
        <DealsSection />
        <FeaturedProducts />
      </main>
      
      <BottomNav />
    </div>
  );
};

export default HomePage;
